module.exports = __webpack_public_path__ + "img/about2.f8501e53.png";